<script setup lang="ts">
const emit = defineEmits(["close"]);
defineProps({
  headerText: {
    type: String,
    required: true,
  },
  bodyText: {
    type: String,
    required: true,
  },
  success: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: null,
  },
});
</script>
<template>
  <div>
    <div class="flex flex-col items-center max-w-xs mx-auto mt-9 mb-6">
      <NuxtIcon
        :name="
          success ? 'mdi:check-circle-outline' : 'mdi:cancel-circle-outline'
        "
        class="w-20 h-20"
        :class="success ? 'text-success-300' : 'text-error-300'" />
      <p
        class="mt-4 text-neutral-200 font-bold text-xl text-center"
        data-test="wallet-created-successfully">
        {{ success ? headerText : $t("main.modalList.transactionFailed") }}
      </p>
      <p v-if="success" class="mt-1 text-neutral-300 text-center">
        {{ bodyText }}
      </p>
      <p v-else class="mt-1 text-neutral-300 text-center">
        {{
          errorMessage
            ? $t(errorMessage)
            : $t("main.modalList.transactionFailedMessage")
        }}
      </p>
    </div>
    <div class="my-4 flex">
      <BaseButtonSubmit
        :text="$t('main.modalList.close')"
        data-test="button-close-modal-listing-success"
        size="long"
        class="mx-auto"
        :contextual-styles="true"
        @click="emit('close')" />
    </div>
  </div>
</template>
